import { createContext } from 'react';
import TeamMemberType from '../domain/teamMember';

const dummyLoggedInTeamMemberContext = null as TeamMemberType | null;

const LoggedInTeamMemberContext = createContext(dummyLoggedInTeamMemberContext);

export default LoggedInTeamMemberContext;
